export function accordion() {

	const $lineBlock = $('.accordion-img');
	const accordion = $('.accordion');
	let accordionItem = $('.accordion-item');
	let $lineDrawingElementPath;
	let animation;
	let animationData;
	let animationArray = [];

	$lineBlock.each(function (index, el) {
		$lineDrawingElementPath = this.dataset.path;
		animationData = {
			container: this,
			renderer: 'svg',
			loop: false,
			autoplay: false,
			path: $lineDrawingElementPath
		};
		animation = bodymovin.loadAnimation(animationData);
		animationArray.push(animation);
	});

	$(window).on('load', function(event) {
		setTimeout(()=>{
			animationArray[0].play();
			accordionItem.eq(0).children('.accordion-content').slideDown('200');
			accordionItem.eq(0).addClass('active');
		},200)

	});


	accordionItem.click(function(){
		let $this = $(this);
		let activeIndex = accordion.find('.active').index();
		let curIndex = $this.index();
		let animationDuration;
		if( !$this.hasClass("active") ){
			animationDuration = Math.round(animationArray[activeIndex].getDuration() * 1000);
			animationArray[activeIndex].setDirection(-1);
			animationArray[activeIndex].play();
			animationArray[activeIndex].setSpeed(3);
			accordion.addClass('disabled');
			setTimeout(function () {
				$this.children('.accordion-content').slideDown('200');
				$this.siblings().children('.accordion-content').slideUp('200');
			}, animationDuration / 3);
			setTimeout(function () {
				$this.addClass('active').siblings().removeClass('active');
				animationArray[curIndex].stop();
				animationArray[curIndex].setDirection(1);
				animationArray[curIndex].play();
				animationArray[curIndex].setSpeed(1);
				accordion.removeClass('disabled');
			}, animationDuration / 3);
		}
	});

}


// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js